/*!jslint
  this
*/
jQuery(function($) {
  "use strict";

    //Animation
    if($('.wp-block-column').length){
      $('.wp-block-column').attr('data-aos', 'fade-up');
      $('.wp-block-column').attr('data-aos-delay', '100');
    }
    AOS.init();
    //Sticky header
    $(window).on('scroll', function (e) {
      if ($(this).scrollTop() >= 50) {
        $(".site-header").addClass("sticky");
      } else {
        $(".site-header").removeClass("sticky");
      }
    });
  // Menu
  $(document).on('click', '.menu-toggle', function (e) {
    $('body').toggleClass('nav-open');
  });

    //Video Banner

    if ($('.vb-video').length) {
      $('.vb-video').magnificPopup({
        type:'iframe',
        midClick: true,
        iframe: {
          markup: '<div class="mfp-iframe-scaler">' +
            '<div class="mfp-close"></div>' +
            '<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
            '</div>',
          patterns: {
            youtube: {
              index: 'youtube.com/',
              id: 'v=',
              src: 'https://www.youtube.com/embed/%id%?autoplay=1'
            }
          }
        }
      });
    }
  
  //Review slider
  if ($('.wr-slide').length) {
    $('.wr-slide').slick({
      dots: false,
      arrows: false,
      slidesToShow: 2,
      autoplay: false,
      infinite: true,
      variableWidth: true,
      autoplaySpeed: 2500,
      autoplay: true,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      }, {
        breakpoint: 600,
        settings: {
          variableWidth: false,
          slidesToShow: 1,
        }
      }, {
        breakpoint: 300,
        settings: {
          variableWidth: false,
          slidesToShow: 1,
        }
      }]
    });
    	// Custom carousel nav
    $(document).on('click', '.arrows-prev', function (e) {
      $(this).parent().parent().parent().find('.wr-slide').slick('slickPrev');
    } );
    
    $(document).on('click', '.arrows-next', function (e) {
      e.preventDefault(); 
      $(this).parent().parent().parent().find('.wr-slide').slick('slickNext');
    } );
  }



    //Gallery slider
    if ($('.gs-slider').length) {
      var $status = $('.pagingInfo');
      var $gallerySlider = $('.gs-slider');
      //Slider Count
      $gallerySlider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.text(i + '/' + slick.slideCount);
      });
      $gallerySlider.slick({
        dots: false,
        arrows: false,
        //slidesToShow: 1,
        infinite: true,
        fade: true,
        autoplaySpeed: 2500,
        autoplay: true,
      });
      //Custom carousel nav
      $(document).on('click', '.arrows-prev', function (e) {
        $(this).parent().parent().parent().parent().find('.gs-slider').slick('slickPrev');
      } );
      
      $(document).on('click', '.arrows-next', function (e) {
        e.preventDefault(); 
        $(this).parent().parent().parent().parent().find('.gs-slider').slick('slickNext');
      } );


    }

    //Gallery slider
    if ($('.gsg-slider').length) {
        
      $('#s1').addClass('active');
      $('.gsg-block h4').text($('[data-slider="s1"]').text());
      $('.gsg-block-select span').text($('[data-slider="s1"]').text());
      $(document).on('click', '.dropdown-item', function (e) {
        var selected = $(this).attr('data-slider');
        var text = $(this).text();
        $('.dropdown-toggle span').text(text);
        $('.gsg-block h4').text(text);
        if($('.gsg-slider').hasClass('active')){
          $('.gsg-slider').removeClass('active');
        }
        $('#'+selected).addClass("active");
      } );

      $('.gsg-slider').each(function() { // the containers for all your galleries
        $(this).magnificPopup({
            delegate: 'a', // the selector for gallery item
            type: 'image',
            gallery: {
              enabled:true
            }
        });
      });
    }


    //Popup Consult
    if ($('.pop').length) {

      $('.pop').magnificPopup({
        type:'inline',
        midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
      })
    }

    //Load more
  $(document).on('click', '.loadmore', function (e) {
    e.preventDefault();
    var $el = $(this),
      $tgt = $el.data('target'),
      link = $el.attr('href');
    if ($el.attr('disabled'))
      return;
    $el.addClass('loading').attr('disabled', true);
    $el.find('span').html('Loading...')
    $("<div>").load(link + $tgt, function () {
      $($tgt).append($(this).find($tgt).html());
      $el.parents('.load-more').removeAttr('disabled').remove();
    });
  });
  $(window).on("scroll", function () {
    if ($('.load-more').length) {
      var TopPos = $('.load-more').offset().top;
      var ST = $(this).scrollTop();
      var FH = $(this).outerHeight();
      if (ST + FH >= TopPos - 300) {
        $('.loadmore').trigger('click');
      }
    }
  });

  //Job slidert
  if ($('.job-slide').length) {
    $('.job-slide').slick({
      dots: false,
      arrows: false,
      slidesToShow: 2,
      infinite: true,
      variableWidth: true,
      autoplaySpeed: 2500,
      autoplay: false,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      }, {
        breakpoint: 600,
        settings: {
          variableWidth: false,
          slidesToShow: 1,
        }
      }, {
        breakpoint: 300,
        settings: {
          variableWidth: false,
          slidesToShow: 1,
        }
      }]
    });
    	// Custom carousel nav
    $(document).on('click', '.arrows-prev', function (e) {
      $(this).parent().parent().parent().find('.job-slide').slick('slickPrev');
    } );
    
    $(document).on('click', '.arrows-next', function (e) {
      e.preventDefault(); 
      $(this).parent().parent().parent().find('.job-slide').slick('slickNext');
    } );
  }



});
